import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardErrorMessage = () => {
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    "data-test-id": "card-error-message",
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "crmCards.errors.loading.description"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "crmCards.errors.loading.ctaWithoutRetryDescription"
      })
    })]
  });
};
export default CardErrorMessage;